import {
  ExternalChatOrganization,
  isExternalChatOrganization,
} from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { useCollectionStore } from "Helpers/StoreHelper";
import { firestore } from "firebase/app";
import { useRef } from "react";

export function useOrganizationsStore() {
  const collectionRef = useRef(
    firestore().collection(CollectionPath.ORGANIZATIONS)
  );

  const sortRef = useRef(
    (a: ExternalChatOrganization, b: ExternalChatOrganization) =>
      a.name.localeCompare(b.name)
  );

  return useCollectionStore<ExternalChatOrganization>({
    collection: collectionRef.current,
    is: isExternalChatOrganization,
    sort: sortRef.current,
  });
}
